module.exports = __webpack_public_path__ + "static/media/MORENA.78ade466.png";